import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const AssetActiveService = {
    list: async (data) => axios.post(API_URL + "/assetActives/list", data).then(({data}) => data).catch((err) => { throw err }),
    get: async (id) => axios.get(API_URL + `/getAssetActives/${id}`).then(({data}) => data).catch((err) => { throw err }),
    create: async (data) => axios.post(API_URL + `/assetActives`, data).then(({data}) => data).catch((err) => { throw err }),
    edit: async (id, data) => axios.post(API_URL + `/assetActives/${id}`, data).then(({data}) => data).catch((err) => { throw err }),
    destroy: async (id) => axios.delete(API_URL + `/assetActives/${id}`).then(({data}) => data).catch((err) => { throw err }),
    getPlaces: async (id, data) => axios.get(API_URL + `/assetPlaces/options/all`, data).then(({data}) => data).catch((err) => { throw err }),
    getAllActives: async (id, data) => axios.get(API_URL + `/assetActives/options/all`, data).then(({data}) => data).catch((err) => { throw err }),
    getAutoComplete: async (search) => axios.get(`${API_URL}/assetActives/description/autocomplete/?search=${search}`).then(({data}) => data).catch((err) => { throw err }),

}

export default AssetActiveService;
